export default "__VITE_ASSET__BkUEcLme__"